import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';
import { Settings } from './types';

export const getSettings = createAsyncThunk<Settings>(
	'getSettings',
	async (params, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/settings`,
			params,
			rejectWithValue,
		});
	},
);
